import Image from '../common/image';
import Benefits from './benefits';

const crowdfunding = {
	path: '/crowdfunding',
	name: 'Crowdfunding',
	title: 'Crowdfunding',
	content: (theme) => (
		<>
			<div className='container pt-5'>
				<div className='row'>
					<div className='col-12'>
						<div className='row gy-4 align-items-center mb-5'>
							<div className='col-md-8'>
								<h2>What is Crowdfunding?</h2>
								<p>
									Crowdfunding is a modern method of raising capital by collecting
									small contributions from a large number of individuals,
									typically through online platforms. This model enables
									entrepreneurs, creators, and organizations to bring their ideas
									to life with the support of a broad community—without relying on
									traditional financing sources like banks or venture capitalists.
								</p>
								<p>
									Through crowdfunding, project creators present their idea to the
									public, set a funding goal, and invite people to contribute over
									a defined period. In return, supporters may receive rewards,
									equity shares, or simply the satisfaction of backing a cause
									they believe in. Crowdfunding platforms make it easy to connect
									with potential backers, share updates, and track funding
									progress in real-time.
								</p>
							</div>
							<div className='col-md-4 text-center'>
								<Image
									className='w-75'
									fileName='blogs/crowdfunding.webp'
								/>
							</div>
							<div className='col-12'>
								<div>
									Crowdfunding can be a valuable tool for startups and
									entrepreneurs who may have difficulty accessing traditional
									forms of funding, such as bank loans or venture capital. By
									using crowdfunding, project creators can test the viability of
									their idea and gauge interest from potential customers before
									investing significant time and resources into the project. In
									addition, crowdfunding allows entrepreneurs to retain ownership
									and control of their company, which may not be possible with
									traditional forms of funding.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Benefits />

			<div className='container pb-5'>
				<div className='row mt-5'>
					<div className='col-12'>
						<h2>Types of crowdfunding</h2>
						<p>
							Crowdfunding comes in four primary forms, each tailored to a different
							purpose and group of contributors:
						</p>
					</div>
				</div>

				<div className='row mb-3 align-items-center'>
					<div className='col-md-1'>
						<Image
							height={'80px'}
							fileName={`blogs/icons_${theme}/financialAssistance.svg`}
						/>
					</div>
					<div className='col-md-11'>
						<h4>1. Donation-Based Crowdfunding</h4>
						<p>
							In this model, contributors offer financial support without expecting
							anything in return. Often used by charities, community projects, and
							individuals in need, the main motivation here is goodwill and belief in
							the cause.
						</p>
						<p>
							<i>Example:</i> Raising funds for educational tools, medical expenses,
							or community programs
						</p>
					</div>
				</div>
				<div className='row mb-3 align-items-center'>
					<div className='col-md-1'>
						<Image
							height={'80px'}
							fileName={`blogs/icons_${theme}/reward.svg`}
						/>
					</div>
					<div className='col-md-11'>
						<h4>2. Reward-Based Crowdfunding</h4>
						<p>
							Supporters receive non-financial incentives in exchange for their
							contribution. These rewards often vary by donation level and may include
							early access to a product, branded merchandise, or exclusive
							experiences.
						</p>
						<p>
							<i>Example:</i> Pre-ordering a tech gadget or receiving a signed artwork
							in return for funding.
						</p>
					</div>
				</div>
				<div className='row mb-3 align-items-center'>
					<div className='col-md-1'>
						<Image
							height={'80px'}
							fileName={`blogs/icons_${theme}/debt.svg`}
						/>
					</div>
					<div className='col-md-11'>
						<h4>3. Debt-Based Crowdfunding (Peer-to-Peer Lending)</h4>
						<p>
							Also known as loan crowdfunding, this model allows supporters to lend
							money to a project or individual. In return, they receive the principal
							back with interest over a specified time. This is ideal for individuals
							or businesses that need financing without giving up ownership.
						</p>
						<p>
							<i>Example:</i> A startup borrows $10,000 and agrees to repay it over 12
							months with 6% interest.
						</p>
					</div>
				</div>
				<div className='row mb-3 align-items-center'>
					<div className='col-md-1'>
						<Image
							height={'80px'}
							fileName={`blogs/icons_${theme}/equity.svg`}
						/>
					</div>
					<div className='col-md-11'>
						<h4>Equity-Based Crowdfunding</h4>
						<p>
							This model turns backers into shareholders. Contributors invest money in
							return for equity—owning a portion of the company. It allows startups to
							raise significant capital while giving investors the potential for
							long-term returns as the business grows.
						</p>
						<p>
							<i>Example:</i> Investing in a tech startup and receiving 2% ownership
							in exchange.
						</p>
					</div>
				</div>
				<div className='row mt-5 mb-3'>
					<div className='col-12'>
						<h2> Why Choose Crowdfunding?</h2>
						<div className='fw-bold fs-4 mt-3'>1. Lower Risk, Higher Potential</div>
						<p>
							By pooling resources from many contributors, projects secure larger
							amounts of capital while spreading the financial risk. This makes it
							easier to launch ideas that might otherwise struggle to get off the
							ground.
						</p>
						<div className='fw-bold fs-4 mt-3'>2. Market Validation</div>
						<p>
							Crowdfunding helps test the market before full-scale launch. If many
							people back the project, it’s a clear sign of demand and potential
							success.
						</p>
						<div className='fw-bold fs-4 mt-3'>3. Retain Control</div>
						<p>
							Unlike traditional financing, where founders often give up
							decision-making power or equity, crowdfunding—especially
							reward-based—lets you keep full ownership while still securing funds.
						</p>
						<div className='fw-bold fs-4 mt-3'>4. Built-in Marketing Power</div>
						<p>
							Supporters often become ambassadors. When backers benefit from a
							project—whether through rewards, equity, or impact—they naturally
							promote it, attracting even more supporters. Crowdfunding is not just
							about money; it's a powerful marketing and community-building tool.
						</p>
					</div>
				</div>
			</div>
		</>
	),
};

export default crowdfunding;
